export const ADDRESS_MAP_URL = '/address-map';
export const ADDRESS_FORM_URL = '/address-form';
